import type * as Types from '../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type ShareYourStayHotelPreviewQueryVariables = Types.Exact<{
  idObject: Types.AccommodationCatalogPropertyIdentifierInput;
}>;

export type ShareYourStayHotelPreviewQuery = {
  __typename?: 'Query';
  accommodationCatalogPropertyById: {
    __typename?: 'AccommodationCatalogProperty';
    joyPlaceId: string;
    name: string;
    address?: { __typename?: 'AccommodationCatalogPropertyAddress'; city?: string | null; country?: string | null; state?: string | null } | null;
    photos: Array<{ __typename?: 'AccommodationCatalogPhoto'; url: string }>;
  };
};

export const ShareYourStayHotelPreviewDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ShareYourStayHotelPreview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'idObject' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AccommodationCatalogPropertyIdentifierInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accommodationCatalogPropertyById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'idObject' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'idObject' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'joyPlaceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photos' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'url' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useShareYourStayHotelPreviewQuery__
 *
 * To run a query within a React component, call `useShareYourStayHotelPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareYourStayHotelPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareYourStayHotelPreviewQuery({
 *   variables: {
 *      idObject: // value for 'idObject'
 *   },
 * });
 */
export function useShareYourStayHotelPreviewQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ShareYourStayHotelPreviewQuery, ShareYourStayHotelPreviewQueryVariables>) {
  return ApolloReactHooks.useQuery<ShareYourStayHotelPreviewQuery, ShareYourStayHotelPreviewQueryVariables>(ShareYourStayHotelPreviewDocument, baseOptions);
}
export function useShareYourStayHotelPreviewLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShareYourStayHotelPreviewQuery, ShareYourStayHotelPreviewQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<ShareYourStayHotelPreviewQuery, ShareYourStayHotelPreviewQueryVariables>(ShareYourStayHotelPreviewDocument, baseOptions);
}
export type ShareYourStayHotelPreviewQueryHookResult = ReturnType<typeof useShareYourStayHotelPreviewQuery>;
export type ShareYourStayHotelPreviewLazyQueryHookResult = ReturnType<typeof useShareYourStayHotelPreviewLazyQuery>;
export type ShareYourStayHotelPreviewQueryResult = Apollo.QueryResult<ShareYourStayHotelPreviewQuery, ShareYourStayHotelPreviewQueryVariables>;
